import React, { useState, createContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { serverContextProps } from './server-context-props';
import type { CMUIServerContext, SetServerContext } from './types';

export interface WithServerContextInjectedProps {
  serverContext: CMUIServerContext;
}

export interface ServerContextWithActionProviderProps {
  context: CMUIServerContext;
  children: React.ReactNode;
}

export const ServerContext = createContext<CMUIServerContext>(undefined as unknown as CMUIServerContext);

export const withServerContext = <Props extends object>(WrappedComponent: React.ComponentType<Props & WithServerContextInjectedProps>) => (
  (props: Props) => (
    <ServerContext.Consumer>
      {(serverContext =>
            (<WrappedComponent
              {...props}
              serverContext={serverContext}
            />))}
    </ServerContext.Consumer>
  )
);

export const ServerContextAction = createContext<SetServerContext>(_.noop as SetServerContext);

export const ServerContextWithActionProvider = (props: ServerContextWithActionProviderProps) => {
  const {
    context,
    children,
  } = props;

  const [serverContext, setServerContext] = useState(context);

  return (
    <ServerContextAction.Provider
      value={setServerContext}
    >
      <ServerContext.Provider value={serverContext}>
        {children}
      </ServerContext.Provider>
    </ServerContextAction.Provider>
  );
};

ServerContextWithActionProvider.propTypes = {
  context: serverContextProps.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
